import { useCallback, useRef, useState } from 'react';

export const useSubmenuHeight = () => {
  const [height, setHeight] = useState<number>(0);
  const submenuRef = useRef<HTMLUListElement>(null);

  const updateHeight = useCallback(() => {
    if (submenuRef.current) {
      // 기본 헤더 높이(100) + 서브메뉴까지의 간격(30) + 여유 높이 (20) + 서브메뉴 높이 ㅠㅠ... 죄송 시간이 없어서... 이렇게 처리했습니다.
      setHeight(100 + 30 + 20 + submenuRef.current.offsetHeight);
    }
  }, []);

  const resetHeight = useCallback(() => {
    setHeight(0);
  }, []);

  return {
    height,
    submenuRef,
    updateHeight,
    resetHeight,
  };
};
